import script from "./PipReviewView.vue?vue&type=script&setup=true&lang=js"
export * from "./PipReviewView.vue?vue&type=script&setup=true&lang=js"

import "./PipReviewView.vue?vue&type=style&index=0&id=3a4cf5aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a4cf5aa"]])

export default __exports__